import type { SVGProps } from 'react';

const SvgAcademyAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13" {...props}>
    <path
      fill={props.color}
      d="M15.719 4.318 8.187.936a.43.43 0 0 0-.362 0L.287 4.318a.51.51 0 0 0-.287.47c0 .206.125.384.306.457l2.879 1.132v4.25c0 .244.169.456.4.489 1.455.225 2.822.755 4.071 1.588l.175.113a.43.43 0 0 0 .494.007l.312-.206a10.1 10.1 0 0 1 3.497-1.442l.306-.067a.496.496 0 0 0 .381-.49V6.37l1.33-.523v7.003h.937V5.483l.606-.238A.5.5 0 0 0 16 4.788a.49.49 0 0 0-.287-.47zM8.006 1.936l6.264 2.813-6.264 2.469-6.264-2.47zm3.884 8.28c-1.33.278-2.585.8-3.74 1.555l-.063.04a10.8 10.8 0 0 0-3.959-1.608V6.748l3.716 1.469q.076.032.162.033a.5.5 0 0 0 .162-.033l3.716-1.47v3.469z"
    />
  </svg>
);

export default SvgAcademyAlt;
